import * as signalR from "@microsoft/signalr";
import { AuthService } from "../../auth/_services/auth.service";

const getAuthHeaders = () => {
    return {
      Authorization: `Bearer ${ localStorage.getItem('token')}`,
    };
  };


export class CustomHttpClient extends signalR.DefaultHttpClient {
    constructor(private authService: AuthService) {
      super(console);
    }
    public override async send(
      request: signalR.HttpRequest
    ): Promise<signalR.HttpResponse> {
      const authHeaders = getAuthHeaders();
      request.headers = { ...request.headers, ...authHeaders };
  
      try {
        const response = await super.send(request);
        return response;
      } catch (er) {
        if (er instanceof signalR.HttpError) {
          const error = er as signalR.HttpError;
          if (error.statusCode == 401) {
             this.authService.refreshToken().subscribe((token)=>{
              if(token){
                const authHeaders = getAuthHeaders();
                request.headers = { ...request.headers, ...authHeaders };
              }
             });
          }
        } else {
          throw er;
        }
      }
      return super.send(request);
    }
  }